import { useQuery } from "@tanstack/react-query";

import { fetchReviewAssignments } from "../../services";
import { SearchServiceSort } from "./search-service";

export const useReviewAssignments = (showOnlyOverdue, employeeNameSearchTerm, sort: SearchServiceSort, skip, limit) => {
	const query = useQuery({
		queryKey: ["review-assignments", showOnlyOverdue, employeeNameSearchTerm, sort, skip, limit],
		queryFn: () => fetchReviewAssignments(showOnlyOverdue, employeeNameSearchTerm, sort, skip, limit),
		meta: {
			errorMessage: "There was an error getting assignments. Please try again later.",
		},
	});

	return query;
};
